// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.8458 17.1447C20.513 17.9133 20.1192 18.6208 19.663 19.2713C19.041 20.158 18.5318 20.7719 18.1393 21.1127C17.5309 21.6722 16.8791 21.9587 16.1811 21.975C15.68 21.975 15.0757 21.8324 14.3723 21.5432C13.6665 21.2553 13.0179 21.1127 12.4249 21.1127C11.803 21.1127 11.1359 21.2553 10.4224 21.5432C9.70786 21.8324 9.13221 21.9832 8.69209 21.9981C8.02274 22.0266 7.35557 21.7319 6.68961 21.1127C6.26457 20.742 5.73292 20.1064 5.09602 19.2061C4.41269 18.2446 3.85089 17.1297 3.41077 15.8587C2.93941 14.4857 2.70312 13.1563 2.70312 11.8692C2.70312 10.3948 3.02171 9.12321 3.65982 8.0576C4.16132 7.20166 4.8285 6.52647 5.66352 6.03081C6.49855 5.53514 7.40079 5.28256 8.37242 5.2664C8.90407 5.2664 9.60126 5.43085 10.4677 5.75405C11.3316 6.07834 11.8863 6.24279 12.1295 6.24279C12.3114 6.24279 12.9276 6.0505 13.9723 5.66714C14.9603 5.31162 15.7941 5.16441 16.4771 5.2224C18.3281 5.37178 19.7186 6.10142 20.6434 7.41595C18.988 8.41896 18.1692 9.82379 18.1855 11.626C18.2004 13.0297 18.7096 14.1979 19.7105 15.1254C20.164 15.5558 20.6706 15.8885 21.2341 16.1248C21.1119 16.4793 20.9829 16.8188 20.8458 17.1447ZM16.6007 0.440125C16.6007 1.54038 16.1987 2.56768 15.3975 3.51854C14.4306 4.64892 13.2612 5.30211 11.9929 5.19904C11.9768 5.06705 11.9674 4.92812 11.9674 4.78214C11.9674 3.7259 12.4272 2.59552 13.2438 1.67127C13.6514 1.20331 14.1699 0.814209 14.7987 0.503814C15.426 0.19805 16.0195 0.0289566 16.5776 0C16.5939 0.147086 16.6007 0.294182 16.6007 0.440111V0.440125Z"
    />
  </svg>
);
const IconApple = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconApple;
